// Visitor.js - Redesigned to match ApplyLeave.js style
import React, { useState, useContext, useEffect } from "react";
import { ProductContext } from "../context/AppContext";
import Header from "./Header";
import { getCachedData, setCachedData } from "../utils/apiCache";
import { Link } from "react-router-dom";
import { all_routes } from "./router/all_routes";
import {
  Container, Modal, Button, Spinner, Row, Col, Card, Badge
} from "react-bootstrap";
import {
  Person, Phone, CalendarEvent, Clock, Image as ImageIcon, FileText, Eye, XCircleFill,Plus
} from "react-bootstrap-icons";
import axios from "axios";
import { QRCodeSVG } from "qrcode.react";

function Visitor() {
  const { userId, Automationdata, StaffData } = useContext(ProductContext);
  const routes = all_routes;
  const authtoken = localStorage.getItem("token");

  const [VisitorData, setVisitorData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState({ url: "", type: "image" }); // image or document
  const [expandedVisitorId, setExpandedVisitorId] = useState(null);
  const [page, setPage] = useState(1);
  const [showGatePassModal, setShowGatePassModal] = useState(false);
  const [selectedVisitorPass, setSelectedVisitorPass] = useState(null);
  const pageSize = 10;
  console.log(StaffData, "StaffData data");
  

  const fetchVisitorData = async () => {
    const cacheKey = 'user_visitors';
    const cached = getCachedData(cacheKey);
    if (cached) {
      setVisitorData(cached);
      setLoading(false);
    }
    try {
      if (!cached) setLoading(true);
      const response = await fetch(
        "https://api.mirai.healthcare/api/visitors/uservisitors",
        {
          headers: { "x-auth": authtoken },
        }
      );
      const result = await response.json();
      if (result.success) {
        setVisitorData(result.data || []);
        setCachedData(cacheKey, result.data || []);
      }
    } catch (error) {
      console.error("Error fetching visitors:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVisitorData();
  }, []);

  const handleVisitorCancel = async (id) => {
    if (!window.confirm("Are you sure you want to cancel this visitor pass?")) return;

    try {
      setLoading(true);
      await axios.patch(
        `https://api.mirai.healthcare/api/visitors/cancel/${id}`,
        { status: "cancel" },
        { headers: { 'x-auth': authtoken } }
      );
      await fetchVisitorData();
      alert("Visitor pass cancelled successfully");
    } catch (error) {
      alert(error.response?.data?.message || "Failed to cancel");
    } finally {
      setLoading(false);
    }
  };

  // Statistics
  const stats = {
    total: VisitorData.length,
    pending: VisitorData.filter(v => v.status?.toLowerCase() === "pending").length,
    approved: VisitorData.filter(v => v.status?.toLowerCase() === "approved").length,
    cancelled: VisitorData.filter(v => ["cancel", "cancelled"].includes(v.status?.toLowerCase())).length,
  };

  const statsCards = [
    { label: "Total Passes", value: stats.total, icon: "ti ti-users", bg: "#e9d8fd", color: "#6f42c1" },
    { label: "Approved", value: stats.approved, icon: "ti ti-circle-check", bg: "#d1fae5", color: "#198754" },
    { label: "Pending", value: stats.pending, icon: "ti ti-clock", bg: "#fef3c7", color: "#f59e0b" },
    { label: "Cancelled", value: stats.cancelled, icon: "ti ti-circle-x", bg: "#fce4ec", color: "#e91e63" },
  ];

  // Sorted & Paginated
  const sortedVisitors = [...VisitorData].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  const paginatedVisitors = sortedVisitors.slice(0, page * pageSize);
  const hasMore = sortedVisitors.length > paginatedVisitors.length;

  const getStatusBadge = (status) => {
    switch (status?.toLowerCase()) {
      case "approved": return "bg-success";
      case "pending": return "bg-warning";
      case "cancel":
      case "cancelled": return "bg-danger";
      default: return "bg-secondary";
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "NA";
    return new Date(dateStr).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  };

  const timeAgo = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diff = Math.floor((now - past) / 1000);
    if (diff < 60) return `${diff}s ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 2592000) return `${Math.floor(diff / 86400)}d ago`;
    return formatDate(dateString);
  };

  const toggleDetails = (id) => {
    setExpandedVisitorId(prev => (prev === id ? null : id));
  };

  const handleViewGatePass = (visitor) => {
    setSelectedVisitorPass(visitor);
    setShowGatePassModal(true);
  };

  const formatPassDate = (dateStr) => {
    if (!dateStr) return "--/--/----";
    return new Date(dateStr).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div className="page-wrapper min-vh-100">
      <Header />

      <div className="content px-4 pt-4">
  {/* Header */}


<div className="d-flex justify-content-between align-items-center my-2 pb-3">
  <div>
            <h2 className="page-title fw-bold mb-0" style={{ letterSpacing: "0.5px" }}>
      Visitor Pass History
    </h2>
    <p className="text-muted">Track all your visitor pass requests</p>
    </div>
            <Link
              to={routes.addvisitor}
              // state={{ StudentGatePassList: StudentGatePassList }}
            >
              <Button
                variant="primary"
                style={{ height: "45px", marginLeft: "20px" }}
              >
                <Plus size={20} />
        Add New Visitor
              </Button>
            </Link>
          </div>

  {/* Statistic Cards */}
  <div className="row g-4 mb-4">
    {statsCards.map((card) => (
      <div className="col-6 col-md-4 col-lg-3" key={card.label}>
        <div className="p-3 rounded-4 shadow-sm h-100 border-0"
             style={{ backgroundColor: "#ffffff" }}>
          <div className="d-flex align-items-center gap-3">
            <div
              className="rounded-circle d-flex justify-content-center align-items-center"
              style={{
                width: "50px",
                height: "50px",
                backgroundColor: card.bg,
                color: card.color,
                fontSize: "22px",
              }}
            >
              <i className={card.icon}></i>
            </div>

            <div>
              <h4 className="fw-bold mb-0">{card.value}</h4>
              <small className="text-muted">{card.label}</small>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>

  {/* Add Visitor Button */}
  {/* <div className="text-end mb-4">
    <Link to={routes.addvisitor}>
      <Button
        variant="primary"
        size="lg"
        className="rounded-pill shadow-sm px-4 py-2 d-flex align-items-center gap-2"
      >
        <Plus size={20} />
        Add New Visitor
      </Button>
    </Link>
  </div> */}



        <div className="card border-0 shadow-sm">
          <div className="card-header bg-white border-0 pb-0">
            <h4 className="mb-0">Visitor Timeline</h4>
          </div>

          <div className="card-body py-4">
            {VisitorData.length === 0 ? (
              <div className="text-center py-5">
                <Person className="text-muted display-1" />
                <h5 className="mt-3 text-muted">No Visitor Passes Yet</h5>
                <p>You haven't created any visitor passes.</p>
                <Link to={routes.addvisitor}>
                  <Button variant="primary">Create First Visitor Pass</Button>
                </Link>
              </div>
            ) : (
              <>
                <div className="timeline position-relative">
                  {paginatedVisitors.map((visitor) => (
                    <div key={visitor.id} className="timeline-item mb-5">
                      <div className="timeline-dot bg-primary rounded-circle">
                        <CalendarEvent className="text-white" />
                      </div>

                      <div className="timeline-content card shadow-sm p-4 border-0 hover-lift">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div>
                            <h5 className="mb-1 text-primary">{visitor.name}</h5>
                            <small className="text-muted fs-14">
                              <Phone className="me-1" size={12} />
                              {visitor.mobile_no}
                            </small>
                          </div>
                          <Badge className={getStatusBadge(visitor.status)}>
                            {visitor.status?.charAt(0).toUpperCase() + visitor.status?.slice(1)}
                          </Badge>
                        </div>

                        <p className="text-muted mb-2 fs-14 text-black">
                          <strong>Purpose:</strong> {visitor.purpose || "Not specified"}
                        </p>

                        <div className="row g-3 text-muted small NewBorderTop">
                          <div className="col-md-5">
                            {/* <p className="mb-2">
                              <strong>Contact To:</strong> {visitor.contact_to || "N/A"}
                            </p> */}
                            <p className="mb-2 fs-14 text-black">
                              <strong>Visit Date:</strong> {formatDate(visitor.visit_date)}
                            </p>
                          </div>
                          <div className="col-md-5">
                            <p className="mb-2 fs-14 text-black">
                              <strong>Applied:</strong> {timeAgo(visitor.createdAt)}
                            </p>
                          </div>
                          <div className="col-md-2 text-md-end">
                            {(visitor.photo || visitor.document) && (
                              <Badge bg="info" className="me-2">Media Attached</Badge>
                            )}
                          </div>
                        </div>

                        <div className="mt-2 d-flex flex-wrap gap-2 justify-content-between align-items-center NewBorderTop pt-3">
                          <div>
                            {visitor.status?.toLowerCase() === "approved" && (
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => handleViewGatePass(visitor)}
                                className="me-2"
                              >
                                <Eye size={14} className="me-1" /> View Pass
                              </Button>
                            )}
                            {visitor.status?.toLowerCase() === "pending" && (
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => handleVisitorCancel(visitor.id)}
                                disabled={loading}
                              >
                                {loading ? <Spinner size="sm" /> : <XCircleFill size={14} className="me-1" />}
                                Cancel Pass
                              </Button>
                            )}
                            {["cancel", "cancelled"].includes(visitor.status?.toLowerCase()) && visitor.remarks && (
                              <span className="text-danger small">
                                <strong>Reason:</strong> {visitor.remarks}
                              </span>
                            )}
                          </div>

                          <div className="d-flex gap-2">
                            {visitor.photo && (
                              <Button
                                variant="outline-info"
                                size="sm"
                                onClick={() => {
                                  setSelectedMedia({ url: visitor.photo, type: "image" });
                                  setShowImageModal(true);
                                }}
                              >
                                <ImageIcon size={14} /> Photo
                              </Button>
                            )}
                            {visitor.document && (
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => {
                                  setSelectedMedia({ url: visitor.document, type: visitor.document.endsWith(".pdf") ? "pdf" : "image" });
                                  setShowImageModal(true);
                                }}
                              >
                                <FileText size={14} /> Document
                              </Button>
                            )}
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => toggleDetails(visitor.id)}
                            >
                              <Eye size={14} className="me-1" />
                              {expandedVisitorId === visitor.id ? "Hide" : "View"} Details
                            </Button>
                          </div>
                        </div>

                        {/* Expanded Details */}
                        {expandedVisitorId === visitor.id && (
                          <div className="mt-4 p-4 bg-light rounded border">
                            <Row className="g-3 small">
                              <Col md={6} className="">
                                <p><strong>Email:</strong> {visitor.email || "N/A"}</p>
                                </Col>
                                <Col md={6} className="">
                                 <p><strong>Created By:</strong> {visitor.createdBy}</p>
                                </Col>
                                </Row>
                                <Row className="g-3 small NewBorderTop mt-2">
                              <Col md={6} className="">
                                <p><strong>Address:</strong> {visitor.address || "N/A"}</p>
                                </Col>
                                <Col md={6} className="">
                                <p><strong>Created At:</strong> {new Date(visitor.createdAt).toLocaleString()}</p>
                                </Col>
                                </Row>
                                <Row className="g-3 small NewBorderTop mt-2">
                              <Col md={6} className="">
                                 <p><strong>Visitor Type:</strong> {visitor.visitor_type || "N/A"}</p>
                                </Col>
                                <Col md={6} className="">
                                <p><strong>Status:</strong> {visitor.status}</p>
                                </Col>
                                </Row>

                                <Row className="g-3 small NewBorderTop mt-2">
                              <Col md={6} className="">
                                 <p><strong>Contact Person ID:</strong> {visitor.contact_to || "N/A"}</p>
                                </Col>
                                <Col md={6} className="">
                                <p><strong>Remarks:</strong> {visitor.remarks || "None"}</p>
                                </Col>
                                </Row>
                                <Row className="g-3 small NewBorderTop mt-2">
                              <Col md={6} className="">
                                 <p><strong>Department ID:</strong> {visitor.dept_id || "N/A"}</p>
                                </Col>
                                <Col md={6} className="">
                                <p><strong>Deleted:</strong> {visitor.is_deleted ? "Yes" : "No"}</p>
                                </Col>
                                </Row>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                {hasMore && (
                  <div className="text-center mt-5">
                    <Button onClick={() => setPage(p => p + 1)} variant="info" size="lg">
                      Load More Visitors
                    </Button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Media Modal */}
      <Modal show={showImageModal} onHide={() => setShowImageModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedMedia.type === "pdf" ? "Document" : "Visitor Photo"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 bg-dark">
          {selectedMedia.type === "pdf" ? (
            <iframe src={selectedMedia.url} style={{ width: "100%", height: "500px", border: "none" }} title="Document" />
          ) : (
            <img src={selectedMedia.url} alt="Visitor media" className="img-fluid"  
            // style={{ width:"100%",height: "300px", objectFit: "contain" }} 
            style={{
    width: "100%",
    height: "500px",
    objectFit: "cover",
    objectPosition: "top"
  }}
            />
          )}
        </Modal.Body>
      </Modal>

      {/* Visitor Gate Pass Modal */}
      <Modal
        show={showGatePassModal}
        onHide={() => setShowGatePassModal(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Visitor Gate Pass</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div id="visitor-gate-pass-content" className="gp-card">
            <div className="gp-header">
              <div className="gp-brand">
                {Automationdata?.data?.[0]?.schoolLogo && (
                  <img
                    src={Automationdata?.data?.[0]?.schoolLogo}
                    alt="School Logo"
                    className="gp-logo"
                  />
                )}
                <div>
                  <h2>{Automationdata?.data?.[0]?.schoolName || "Erish"}</h2>
                  <p>Visitor Entry Gate Pass</p>
                </div>
              </div>
              <div className="gp-status-wrap">
                <div className="gp-status">APPROVED</div>
                <div className="gp-date">
                  Date: {formatPassDate(selectedVisitorPass?.visit_date)}
                </div>
              </div>
            </div>

            <div className="gp-main">
              <div className="gp-student-col">
                <div className="gp-avatar-wrap">
                  <img
                    src={selectedVisitorPass?.photo || "https://via.placeholder.com/220"}
                    alt="Visitor"
                    className="gp-avatar"
                  />
                </div>
                <h3>{selectedVisitorPass?.name || "Visitor"}</h3>
                <div className="gp-student-id">Mob: {selectedVisitorPass?.mobile_no || "N/A"}</div>
                <div className="gp-class-chip">
                  {selectedVisitorPass?.visitor_type || "Visitor"}
                </div>
              </div>

              <div className="gp-details-col">
                <h4>VISIT DETAILS</h4>
                <div className="gp-detail-item">
                  <label>Contact To</label>
                  <p>{selectedVisitorPass?.contact_to || "N/A"}</p>
                </div>
                <div className="gp-detail-item">
                  <label>Address</label>
                  <p>{selectedVisitorPass?.address || "N/A"}</p>
                </div>
                <div className="gp-detail-item">
                  <label>Purpose</label>
                  <p>{selectedVisitorPass?.purpose || "N/A"}</p>
                </div>

                <div className="gp-times">
                  <div className="gp-time-box">
                    <span>Out Time</span>
                    <strong className="gp-out-time">
                      {selectedVisitorPass?.out_time || "--:--:--"}
                    </strong>
                  </div>
                  <div className="gp-time-box">
                    <span>In Time</span>
                    <strong className="gp-in-time">
                      {selectedVisitorPass?.in_time || "--:--:--"}
                    </strong>
                  </div>
                </div>
              </div>

              <div className="gp-qr-col">
                <h4>SCAN QR</h4>
                <div className="gp-qr-box">
                  <QRCodeSVG
                    value={JSON.stringify({
                      id: selectedVisitorPass?.id,
                      type: "visitor_gate_pass",
                      status: selectedVisitorPass?.status,
                    })}
                    size={170}
                  />
                </div>
                <div className="gp-sign-wrap">
                  <div className="gp-sign-line"></div>
                  <div className="gp-sign-title">Authorized Signature</div>
                  <div className="gp-sign-by">Admin/Teacher</div>
                </div>
              </div>
            </div>

            <div className="gp-footer">
              This is a computer-generated gate pass and is valid only for the
              date and time mentioned above.
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="me-2" onClick={() => setShowGatePassModal(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              const card = document.getElementById("visitor-gate-pass-content");
              if (!card) return;

              const printWindow = window.open("", "", "height=900,width=1400");
              const printStyles = `
                <style>
                  * { box-sizing: border-box; font-family: Arial, sans-serif; }
                  @page { size: A4 landscape; margin: 8mm; }
                  body {
                    margin: 0;
                    background: #fff;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                  }
                  .gp-card {
                    width: 100%;
                    // border: 3px solid #111;
                    border-radius: 18px;
                    padding: 28px 34px;
                    color: #1f2933;
                  }
                  .gp-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    padding-bottom: 20px;
                    border-bottom: 2px solid #d8dee4;
                  }
                  .gp-brand {
                    display: flex;
                    align-items: center;
                    gap: 18px;
                  }
                  .gp-logo {
                    width: 170px;
                    max-height: 88px;
                    object-fit: contain;
                  }
                  .gp-brand h2 {
                    margin: 0;
                    color: #1e67da;
                    font-size: 56px;
                    line-height: 1;
                    font-weight: 700;
                  }
                  .gp-brand p {
                    margin: 10px 0 0;
                    font-size: 22px;
                    color: #5e6a75;
                  }
                  .gp-status-wrap { text-align: right; }
                  .gp-status {
                    display: inline-block;
                    background: #1f9254;
                    color: #fff;
                    font-size: 24px;
                    font-weight: 700;
                    padding: 12px 28px;
                    border-radius: 10px;
                  }
                  .gp-date {
                    margin-top: 12px;
                    color: #5e6a75;
                    font-size: 20px;
                  }
                  .gp-main {
                    display: grid;
                    grid-template-columns: 1fr 1.5fr 1fr;
                    margin: 26px 0;
                    min-height: 420px;
                  }
                  .gp-student-col, .gp-details-col, .gp-qr-col { padding: 0 24px; }
                  .gp-details-col, .gp-qr-col { border-left: 2px solid #d8dee4; }
                  .gp-student-col { text-align: center; }
                  .gp-avatar-wrap {
                    width: 230px;
                    height: 230px;
                    border-radius: 999px;
                    border: 2px solid #d5dbe0;
                    padding: 8px;
                    margin: 0 auto 14px;
                  }
                  .gp-avatar {
                    width: 100%;
                    height: 100%;
                    border-radius: 999px;
                    object-fit: cover;
                  }
                  .gp-student-col h3 {
                    margin: 0;
                    font-size: 42px;
                    font-weight: 700;
                  }
                  .gp-student-id {
                    margin-top: 4px;
                    font-size: 22px;
                    color: #6c7782;
                  }
                  .gp-class-chip {
                    margin-top: 10px;
                    display: inline-block;
                    border: 2px solid #c9cfd5;
                    border-radius: 9px;
                    padding: 8px 18px;
                    font-size: 20px;
                    font-weight: 700;
                    background: #f4f6f8;
                  }
                  .gp-details-col h4, .gp-qr-col h4 {
                    margin: 0 0 18px;
                    color: #616d78;
                    letter-spacing: 3px;
                    font-size: 18px;
                    font-weight: 700;
                  }
                  .gp-detail-item { margin-bottom: 18px; }
                  .gp-detail-item label {
                    display: block;
                    color: #66727d;
                    font-size: 15px;
                    margin-bottom: 2px;
                  }
                  .gp-detail-item p {
                    margin: 0;
                    font-size: 22px;
                    color: #222a31;
                    font-weight: 600;
                  }
                  .gp-times {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 12px;
                    margin-top: 10px;
                  }
                  .gp-time-box {
                    border: 2px solid #c9cfd5;
                    border-radius: 10px;
                    background: #f4f6f8;
                    padding: 12px;
                    text-align: center;
                  }
                  .gp-time-box span {
                    display: block;
                    color: #66727d;
                    font-size: 14px;
                    margin-bottom: 2px;
                  }
                  .gp-time-box strong { font-size: 21px; }
                  .gp-out-time { color: #dc3545; }
                  .gp-in-time { color: #1f9254; }
                  .gp-qr-col {
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                  }
                  .gp-qr-box {
                    border: 2px solid #d8dee4;
                    border-radius: 8px;
                    padding: 10px;
                    display: inline-block;
                  }
                  .gp-sign-wrap { margin-top: 16px; }
                  .gp-sign-line {
                    width: 85%;
                    margin: 0 auto 10px;
                    border-bottom: 2px solid #c9cfd5;
                  }
                  .gp-sign-title { color: #5e6a75; font-size: 18px; }
                  .gp-sign-by {
                    margin-top: 4px;
                    color: #1e67da;
                    font-size: 18px;
                    font-weight: 700;
                  }
                  .gp-footer {
                    border-top: 2px solid #d8dee4;
                    text-align: center;
                    color: #5e6a75;
                    font-size: 18px;
                    padding-top: 18px;
                  }
                </style>
              `;

              printWindow.document.write("<html><head><title>Visitor Gate Pass</title>");
              printWindow.document.write(printStyles);
              printWindow.document.write("</head><body>");
              printWindow.document.write(card.outerHTML);
              printWindow.document.write("</body></html>");
              printWindow.document.close();
              setTimeout(() => {
                printWindow.focus();
                printWindow.print();
              }, 400);
            }}
          >
            <i className="ti ti-printer me-2"></i> Print Pass
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Global Styles - Same as ApplyLeave */}
      <style jsx>{`
        .stats-scroll {
          display: flex; gap: 1rem; overflow-x: auto; padding-bottom: 0.5rem;
          scroll-snap-type: x proximity;
        }
        .stats-scroll::-webkit-scrollbar { height: 6px; }
        .stats-scroll::-webkit-scrollbar-thumb {
          background: rgba(13, 110, 253, 0.4); border-radius: 999px;
        }
        .stats-card { min-width: 200px; flex: 0 0 auto; border-radius: 16px; scroll-snap-align: start; }
        .stats-icon {
          width: 48px; height: 48px; border-radius: 14px;
          display: inline-flex; align-items: center; justify-content: center;
        }
        .timeline { padding-left: 40px; }
        .timeline::before {
          content: ""; position: absolute; left: 20px; top: 0; bottom: 0;
          width: 3px; background: linear-gradient(to bottom, #0d6efd, #0dcaf0);
          border-radius: 2px;
        }
        .timeline-item { position: relative; }
        .timeline-dot {
          position: absolute; left: -40px; top: 15px; width: 40px; height: 40px;
          background: #0d6efd; border: 5px solid #fff; box-shadow: 0 0 0 4px #cfe2ff;
          display: flex; align-items: center; justify-content: center; z-index: 1;
        }
        .timeline-content {
          border-radius: 16px; transition: all 0.3s ease;
        }
        .hover-lift:hover {
          transform: translateY(-6px);
          box-shadow: 0 15px 35px rgba(13, 110, 253, 0.15) !important;
        }
        .gp-card {
          width: 100%;
          // border: 2px solid #111;
          border-radius: 16px;
          padding: 24px 26px;
          color: #1f2933;
          background: #fff;
        }
        .gp-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          border-bottom: 2px solid #e3e8ee;
          padding-bottom: 16px;
        }
        .gp-brand {
          display: flex;
          gap: 16px;
          align-items: center;
        }
        .gp-logo {
          width: 95px;
          max-height: 65px;
          object-fit: contain;
        }
        .gp-brand h2 {
          margin: 0;
          color: #1e67da;
          font-size: 36px;
          font-weight: 700;
        }
        .gp-brand p {
          margin: 4px 0 0;
          color: #5e6a75;
          font-size: 25px;
        }
        .gp-status {
          display: inline-block;
          background: #1f9254;
          color: #fff;
          padding: 8px 20px;
          border-radius: 8px;
          font-weight: 700;
          font-size: 20px;
        }
        .gp-date {
          margin-top: 8px;
          font-size: 17px;
          color: #5e6a75;
        }
        .gp-main {
          display: grid;
          grid-template-columns: 1fr 1.5fr 1fr;
          margin: 20px 0;
          min-height: 330px;
        }
        .gp-student-col,
        .gp-details-col,
        .gp-qr-col {
          padding: 0 20px;
        }
        .gp-details-col,
        .gp-qr-col {
          border-left: 2px solid #e3e8ee;
        }
        .gp-student-col {
          text-align: center;
        }
        .gp-avatar-wrap {
          width: 180px;
          height: 180px;
          border: 2px solid #d4dbe2;
          border-radius: 999px;
          padding: 7px;
          margin: 0 auto 12px;
        }
        .gp-avatar {
          width: 100%;
          height: 100%;
          border-radius: 999px;
          object-fit: cover;
        }
        .gp-student-col h3 {
          margin: 0;
          font-weight: 700;
          font-size: 42px;
        }
        .gp-student-id {
          margin-top: 4px;
          color: #66727d;
          font-size: 22px;
        }
        .gp-class-chip {
          margin-top: 10px;
          display: inline-block;
          border: 2px solid #c9cfd5;
          background: #f4f6f8;
          border-radius: 8px;
          padding: 6px 14px;
          font-weight: 700;
          font-size: 20px;
        }
        .gp-details-col h4,
        .gp-qr-col h4 {
          margin: 0 0 14px;
          letter-spacing: 2px;
          color: #616d78;
          font-size: 15px;
          font-weight: 700;
        }
        .gp-detail-item {
          margin-bottom: 14px;
        }
        .gp-detail-item label {
          display: block;
          font-size: 14px;
          color: #66727d;
        }
        .gp-detail-item p {
          margin: 2px 0 0;
          font-size: 28px;
          font-weight: 600;
          color: #212830;
          line-height: 1.2;
        }
        .gp-times {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
        }
        .gp-time-box {
          border: 2px solid #c9cfd5;
          background: #f4f6f8;
          border-radius: 9px;
          text-align: center;
          padding: 10px 8px;
        }
        .gp-time-box span {
          display: block;
          color: #66727d;
          font-size: 13px;
        }
        .gp-time-box strong {
          display: block;
          margin-top: 2px;
          font-size: 30px;
        }
        .gp-out-time {
          color: #dc3545;
        }
        .gp-in-time {
          color: #1f9254;
        }
        .gp-qr-col {
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .gp-qr-box {
          display: inline-block;
          border: 2px solid #d4dbe2;
          border-radius: 8px;
          padding: 8px;
          background: #fff;
        }
        .gp-sign-line {
          width: 82%;
          margin: 0 auto 8px;
          border-bottom: 2px solid #d4dbe2;
        }
        .gp-sign-title {
          color: #5e6a75;
          font-size: 17px;
        }
        .gp-sign-by {
          color: #1e67da;
          font-size: 18px;
          font-weight: 700;
        }
        .gp-footer {
          border-top: 2px solid #e3e8ee;
          padding-top: 14px;
          text-align: center;
          color: #5e6a75;
          font-size: 16px;
        }
        @media (max-width: 991px) {
          .gp-main {
            grid-template-columns: 1fr;
            gap: 20px;
          }
          .gp-details-col,
          .gp-qr-col {
            border-left: none;
            border-top: 1px solid #e3e8ee;
            padding-top: 16px;
          }
          .gp-brand h2 {
            font-size: 22px;
          }
          .gp-brand p {
            font-size: 15px;
          }
        }
      `}</style>
    </div>
  );
}

export default Visitor;
